module.exports = __webpack_public_path__ + "img/CX.1aa23608.png";